import React, { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { useAuth } from 'src/hooks/useAuth.hook';
import { isDomainAllowedForIntercom } from 'src/utils/domainUtils';

/**
 * IntercomWidget component that displays the Intercom chatbot
 * Only displays for authenticated users on allowed domains: amiktechnologies.com, amiktech.in, avvtech.ca, localhost
 */
export default function IntercomWidget() {
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    // Only initialize Intercom if the current domain is allowed AND user is authenticated
    if (!isDomainAllowedForIntercom()) {
      return; // Exit early if domain is not allowed
    }

    // Only show Intercom for authenticated users
    if (isAuthenticated && user) {
      // Authenticated user - include user data
      Intercom({
        app_id: 'p7s9neqc',
        user_id: user._id || user.id, // Use _id or id from user object
        name: user.name || user.username, // Use name or username as fallback
        email: user.email, // User email
        created_at: user.createdAt ? Math.floor(new Date(user.createdAt).getTime() / 1000) : undefined, // Convert to Unix timestamp
      });

      // Optional: Add custom CSS for positioning
      addIntercomCustomStyles();
    }
    // Note: Intercom will not be initialized for non-authenticated users
  }, [isAuthenticated, user]);

  // Function to add custom styles for Intercom positioning
  const addIntercomCustomStyles = () => {
    // Check if styles already exist
    if (document.getElementById('intercom-custom-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'intercom-custom-styles';
    style.textContent = `
      /* Custom Intercom positioning */
      #intercom-container {
        bottom: 20px !important;
        right: 20px !important;
        z-index: 1000 !important;
      }
      
      /* Optional: Hide on mobile devices */
      @media (max-width: 768px) {
        #intercom-container {
          bottom: 10px !important;
          right: 10px !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  // This component doesn't render anything visible
  // Intercom widget will appear as a floating chat bubble
  return null;
}
